import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password must be at least 6 characters");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login", { replace: true });
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="reset-page">
      <h1 className="font-display text-3xl font-extrabold uppercase tracking-tight text-center">Set New Password</h1>
      {!token ? (
        <p className="text-center text-sm text-red-400 mt-4">Invalid or missing reset link.</p>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div><Label className="text-xs">New Password</Label><Input data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="bg-zinc-900 border-zinc-800 mt-1.5" /></div>
          <button type="submit" disabled={loading} data-testid="reset-submit" className="w-full rounded-full bg-brand text-black py-3 text-sm font-bold uppercase tracking-wide hover:bg-brand-hover active:scale-95 transition disabled:opacity-60 flex items-center justify-center gap-2">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Update Password"}
          </button>
        </form>
      )}
      <p className="text-center mt-8"><Link to="/login" data-testid="back-to-signin" className="font-mono text-xs uppercase tracking-widest text-zinc-500 hover:text-brand">← Back to sign in</Link></p>
    </div>
  );
}
